export const propertyHasChanged = (oldProp, newProp) => JSON.stringify(oldProp) !== JSON.stringify(newProp);

export const logObject = (obj, component = '') => console.log(`${ component }: ${ JSON.stringify(obj) }`); // eslint-disable-line no-console

export const isBlank = (str) => str === '' || str === null || str === undefined;



// WEBPACK FOOTER //
// ./frontend/a2i/js/lib/objectComparison.js